var map = {
	"./affordinginsurance.com/content/data.json": 8456,
	"./alcatrazblog.com/content/data.json": 918,
	"./bestpropertyguides.net/content/data.json": 58,
	"./dailyhistoryfacts.org/content/data.json": 3477,
	"./everydayhealthguide.net/content/data.json": 3889,
	"./financial-money.com/content/data.json": 1644,
	"./financialsinfo.com/content/data.json": 26,
	"./findyourfit.net/content/data.json": 1105,
	"./jokeoftheday.info/content/data.json": 3660,
	"./newproductsforyou.com/content/data.json": 4586,
	"./savvyfinancetips.net/content/data.json": 2079,
	"./secretbeautydiscounts.com/content/data.json": 8078,
	"./sportshistory.info/content/data.json": 8920,
	"./template.com/content/data.json": 592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7410;